<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="d-none d-md-block">
            <div class="green-filter d-flex" v-if="!showTransportFilter">
                <span 
                    v-for="(item, index) in greenFilterMenu" 
                    :key="index" 
                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                    @click="changeActive(index)"
                >
                    {{ item.title }}
                </span>

                <b-button
                    v-if="activeIndex == 2"
                    title="Открыть фильтр по транспортным компаниям"
                    size="sm"
                    :variant="showTransportFilter ? 'primary' : 'secondary'"
                    id="filter-ts_off"
                    @click="showTransportFilter=!showTransportFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр по транспортным компаниям"></b-icon>
                </b-button>
            </div>
            <div class="d-flex position-relative" v-if="activeIndex == 2">
                <div v-show="showTransportFilter">
                    <b-button
                        title="Закрыть фильтр по транспортным компаниям"
                        size="sm"
                        class="mr-3"
                        :variant="showTransportFilter ? 'primary' : 'secondary'"
                        id="filter-ts_on"
                        @click="showTransportFilter=!showTransportFilter"
                    >
                        <b-icon icon="filter-square" scale="1" aria-label="Фильтр по транспортным компаниям"></b-icon>
                    </b-button>

                    <FilterByTransportCompanies
                        @startSearch="startSearch"
                        @disableSearch="disableSearch"
                    ></FilterByTransportCompanies>
                </div>
            </div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <!-- Основные фильтры -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Тип компаний</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>

                <!-- Фильтр транспортных компаний -->
                <div class="mobile-filter-section" v-if="activeIndex == 2">
                    <h6 class="mobile-filter-title">Фильтр транспортных компаний</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${showTransportFilter ? 'active' : ''}`"
                            @click="showTransportFilter = !showTransportFilter; closeMobileMenu()"
                        >
                            {{ showTransportFilter ? 'Скрыть фильтр' : 'Показать фильтр' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Мобильная версия фильтра транспортных компаний -->
        <div class="d-block d-md-none" v-if="activeIndex == 2 && showTransportFilter">
            <div class="mobile-transport-filter">
                <FilterByTransportCompanies
                    @startSearch="startSearch"
                    @disableSearch="disableSearch"
                ></FilterByTransportCompanies>
            </div>
        </div>
    </div>
</template>
<script>
    import FilterByTransportCompanies from "@/components/companies/CompanyTableFilterByTransportCompanies";
    import {
        dataHelpers
    } from '@/mixins';

    export default {
        props: {
            api: {type: String, required: true},              // Link on API for table working
        },
        components: {
            FilterByTransportCompanies
        },
        mixins: [
            dataHelpers
        ],        
        data() {
            return {
                isMobileMenuOpen: false,
                activeIndex: 0,
                showTransportFilter: false,
                additionalParameter: '',
                greenFilterMenu: [
                    {title: "Клиенты B2C", active: true, is_transport_company: false, is_b2c_rezident: true},
                    {title: "Все клиенты", active: true, is_transport_company: false, is_b2c_rezident: false},
                    // {title: "Мои клиенты", active: false, where_iam_sales_manager: true, is_transport_company: false, is_b2c_rezident: false},
                    {title: "Транспортные компании", active: false, is_transport_company: true, is_b2c_rezident: false},
                ]
            }
        },
        mounted() {
            this.changeActive(this.$store.state.userLocalSettings.filterSettings.companyTable)
        },
        methods: {
            changeActive(activeIndex) {
                let additionalParameter = '';

                this.activeIndex = activeIndex;

                this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                    name: 'companyTable',
                    value: activeIndex
                });

                this.greenFilterMenu.forEach((item, index) => {
                    item.active = false;
                    if (activeIndex == index) {
                        item.active = true;
                        if (item.where_iam_sales_manager) {
                            additionalParameter += '&where_iam_sales_manager=true';
                        }
                        if (item.is_b2c_rezident) {
                            additionalParameter += '&is_b2c_rezident=1';
                        } else {
                            additionalParameter += '&is_b2c_rezident=0';
                        }
                        if (item.is_transport_company) {
                            additionalParameter += '&is_transport_company=1&headerName=tableHeadersSupplier';
                        } else {
                            additionalParameter += '&is_transport_company=0';
                        }
                    }
                })
                this.additionalParameter = additionalParameter;
                this.$emit('setFilteringApiParameter', additionalParameter);
            },
            startSearch(searchData) {
                this.$emit('setFilteringApiParameter', this.additionalParameter + '&' + this.objectToQueryString(searchData));
                this.showTransportFilter = false;
            },
            disableSearch(value) {
                this.showTransportFilter = false;
            },

            // Методы для мобильного меню
            toggleMobileMenu() {
                this.isMobileMenuOpen = !this.isMobileMenuOpen;
            },

            closeMobileMenu() {
                this.isMobileMenuOpen = false;
            }
        }
    }
</script>

<style scoped>
.mobile-transport-filter {
    margin-top: 10px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 5px;
}
</style>
